module.exports = __webpack_public_path__ + "img/logo-presse-it-numerique-200x200.19f2a93f.jpg";